// extracted by mini-css-extract-plugin
export var label = "_40-1";
export var reminder = "_40-0";